import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d0f42fc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/php7/nickyeconomou.com/public/site/nickyeconomou/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0f42fc')) {
      api.createRecord('6d0f42fc', component.options)
    } else {
      api.reload('6d0f42fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d0f42fc&", function () {
      api.rerender('6d0f42fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/accessibility-helper/index.vue"
export default component.exports